












import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-tag' })
export default class VTag extends Vue {
    /**
     * Whether the tag is semantically a button
     */
    @Prop({ type: Boolean, default: false })
    button!: boolean

    /**
     * Style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: 'primary' | 'dark' | 'primary-mini' | 'white'

    /**
     * Style size
     */
    @Prop({ type: String, default: 'sm' })
    size!: 'sm' | 'md' | 'lg'

    /**
     * At which brightness to invert the colours
     */
    @Prop({ type: String })
    invert!: 'light' | 'dark'
}
